module.exports = __webpack_public_path__ + "static/prepped-desktop-3-509f00310278e3b5a658503d461fce05.jpg";